<template>
  <v-container fluid>
    <PageHeading
      :text="$t('page-attributes.title')"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-attribute-new'
          }"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          Создать атрибут
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridAttributes ref="grid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageHeading from '@/components/page-heading'
import GridAttributes from './grid'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageAttributes',
  components: {
    PageHeading,
    GridAttributes
  },
  metaInfo () {
    const titleLocale = this.$t('page-attributes.title')
    return {
      title: titleLocale
    }
  },
  methods: {},

  mixins: [gridPageInterface]
}
</script>
